import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickOrderBanner = () => {
  const handleWhatsAppOrder = () => {
    window.open('https://wa.me/211915497014?text=Hello%20Chapati%20Plus!%20I%20would%20like%20to%20place%20an%20order.', '_blank');
  };

  return (
    <section className="bg-gradient-to-r from-primary to-primary/80 py-8 md:py-12 lg:py-16 my-8 md:my-12 lg:my-16 rounded-2xl overflow-hidden relative">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="text-center space-y-4 md:space-y-6">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
            <Icon name="Zap" size={20} color="white" />
            <span className="text-white font-semibold text-sm md:text-base">Quick & Easy Ordering</span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
            Can't Decide? Let Us Help!
          </h2>

          <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto">
            Chat with us on WhatsApp for personalized recommendations or call us directly for instant assistance.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 pt-4">
            <Button
              variant="default"
              size="lg"
              iconName="MessageCircle"
              iconPosition="left"
              onClick={handleWhatsAppOrder}
              className="bg-accent hover:bg-accent/90 text-accent-foreground w-full sm:w-auto"
            >
              Order on WhatsApp
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              onClick={() => window.open('tel:+211915497014', '_self')}
              className="bg-white hover:bg-white/90 text-primary border-white w-full sm:w-auto"
            >
              Call +211 915 497 014
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 pt-6 text-white/80 text-sm md:text-base">
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={18} />
              <span>Open Daily 8AM-10PM</span>
            </div>
            <div className="w-1 h-1 bg-white/60 rounded-full hidden sm:block"></div>
            <div className="flex items-center gap-2">
              <Icon name="Truck" size={18} />
              <span>Fast Delivery</span>
            </div>
            <div className="w-1 h-1 bg-white/60 rounded-full hidden sm:block"></div>
            <div className="flex items-center gap-2">
              <Icon name="ShieldCheck" size={18} />
              <span>Quality Guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickOrderBanner;